import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupInfoComponent } from './group-info.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddressInputModule } from '@schoolbelle/api/address-input';

@NgModule({
  declarations: [GroupInfoComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,

    AddressInputModule.forRoot(),
  ],
  exports: [GroupInfoComponent],
})
export class GroupInfoModule { }
